/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constants';

export const getCSVListing = (payload, callback) =>
  req.list(
    c.GET_CSV_LISTING,
    `/${c.CSV_UPLOAD_LISTING}`,
    payload,
    callback
  );
